import React from "react";
import api from "../../services/api";
// Componente funcional para lidar com o carregamento do vídeo
const VideoPlayerComponete = ({ mediaUrl, className }) => {
	const [videoSrc, setVideoSrc] = React.useState(null);
  
	React.useEffect(() => {
	  const fetchVideo = async () => {
		try {
		  const { data, headers } = await api.get(`/obter-arquivo/${mediaUrl}`, {
			responseType: "blob",
		  });
		  const blob = new Blob([data], { type: headers["content-type"] || "video/mp4" });
		  const url = window.URL.createObjectURL(blob);
		  setVideoSrc(url);
		} catch (err) {
		  console.error("Erro ao carregar o vídeo:", err);
		}
	  };
  
	  fetchVideo();
	}, [mediaUrl]);
  
	return (
	  <div className={className}>
		{videoSrc ? (
		  <video controls style={{ width: "100%", maxHeight: "500px" }} src={videoSrc}>
			Seu navegador não suporta vídeos.
		  </video>
		) : (
		  <p>Carregando vídeo...</p>
		)}
	  </div>
	);
  };
  

export default VideoPlayerComponete;